module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_brodno_adults-240f82698c3d3418f73deb55eb194452.svg";